import styled from 'styled-components';
import { layout, styledUtils } from '@prisjakt/ui-base';
import StoreLogo from '@prisjakt/ui-store-logo';
import Clickable from '@prisjakt/ui-clickable';

export const Store = styled(Clickable)`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  padding: ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.xSmall};

  &::after {
    ${styledUtils.overlay()}
    border-radius: 5px;
    pointer-events: none;
    transition: background-color 150ms ease;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;

export const Logo = styled(StoreLogo)`
  margin-right: ${layout.spacing.xSmall};
`;

export const Count = styled.div`
  margin-left: ${layout.spacing.xxSmall};
  color: ${p => p.theme.text.quaternary};
`;
